/* eslint-disable import/no-duplicates */
import type { Locale } from 'date-fns';
import fr from 'date-fns/locale/fr';
import en from 'date-fns/locale/en-US';

const locales: Record<SupportedLangs, Locale> = {
    fr,
    en,
};

export default locales;
